<template>
  <div class="member-wrapper">
    <div class='content'>
      <van-cell-group>
        <van-field v-model.trim="params.SurName" required clearable label="姓" name="surName" maxlength=10 v-validate="rules.surName" :error-message="errors.first('surName')" placeholder="请输入姓" autocomplete="off" />
        <van-field v-model.trim="params.GivenName" required clearable label="名" name="givenName" maxlength=10 v-validate="rules.givenName" :error-message="errors.first('givenName')" placeholder="请输入名" autocomplete="off" />
        <van-field v-model="genderText" readonly label="性别" name="genderText" placeholder="请选择" @click="modalShow.gender=true" is-link />
        <van-field readonly clickable name="calendar" :value="params.Birthday" label="生日信息" placeholder="点击选择生日信息" @click="showCalendar = true" />
        <van-field v-model="params.Mobile" :readonly='isMobileReadOnly' clearable label="联系电话" name="telphone" v-validate="rules.telphone" :error-message="errors.first('telphone')" placeholder="请输入联系电话" autocomplete="off" />
        <van-field v-model.trim="params.Email" :readonly='isEmailReadOnly' required clearable label="邮箱" name="email" v-validate="rules.email" :error-message="errors.first('email')" placeholder="请输入邮箱" autocomplete="off" />
        <van-field v-model.trim="params.HospitalTextName" required clearable maxlength=25 label="医院名称" name="hospitalName" v-validate="rules.hospitalName" :error-message="errors.first('hospitalName')" placeholder="请输入医院名称" autocomplete="off" />
        <van-field v-model.trim="params.ZipCode" clearable label="邮编" name="zipCode" v-validate="rules.zipCode" :error-message="errors.first('zipCode')" placeholder="请输入邮编" autocomplete="off" />
        <van-field v-model="addressText" required label="省市区" name="provinceArea" v-validate="rules.provinceArea" :error-message="errors.first('provinceArea')" placeholder="请选择" @click="modalShow.area=true" is-link />
        <van-field v-model="params.Address" required clearable maxlength=500 name="hospitalAddress" v-validate="rules.hospitalAddress" :error-message="errors.first('hospitalAddress')" label="医院地址" placeholder="请输入医院地址" autocomplete="off" />
        <van-field v-model.trim="params.Introduction" clearable type='textarea' label="简介" maxlength=500 placeholder="描述不超过500字" autocomplete="off" />
      </van-cell-group>
      <div class='btn-wrap'>
        <div class='btn-box'>
          <van-button type="primary" round size="large" @click='handleSave' :disabled="saveDisabled">保存</van-button>
        </div>
      </div>
    </div>
    <!--性别-->
    <van-popup v-model="modalShow.gender" position="bottom">
      <van-picker show-toolbar :columns="optData.gender" @confirm="changeGenderOptData" @cancel="closeModal('gender')" value-key="text" />
    </van-popup>
    <!--省市区-->
    <van-popup v-model="modalShow.area" position="bottom">
      <div class="select-area-wrap">
        <div class="btn">
          <a class="cancel" @click="closeModal('area')">取消</a>
          <a class="confirm" @click="confirmChoseAreaData">确定</a>
        </div>
        <div class="list-box">
          <van-picker class="area-list" :columns="optData.areaOpt.country" @change="getSubArea" :default-index="choseAreaKey.countryIndex" value-key="Name" />
          <van-picker class="area-list" :columns="optData.areaOpt.province" @change="getSubArea" :default-index="choseAreaKey.provinceIndex" value-key="Name" />
          <van-picker class="area-list" :columns="optData.areaOpt.city" @change="getSubArea" :default-index="choseAreaKey.cityIndex" value-key="Name" />
          <van-picker class="area-list" :columns="optData.areaOpt.area" @change="getSubArea" :default-index="choseAreaKey.areaIndex" value-key="Name" />
        </div>
      </div>
    </van-popup>
    <van-calendar v-model="showCalendar" :default-date="defaultBirthDate" @confirm="birthConfirm" />
  </div>
</template>
<script>
import { Toast } from "vant";
import store from "@/store";
export default {
  data () {
    return {
      params: {
        AppID: this.GLOBAL.AppID,
        // Method: 'UpdateUserRegister',
        Method: 'UpdateUserRegisterV1',
        RegionID: '',//地区编号
        Address: '',//详细地址:maxlength:500
        SurName: '',//姓:maxlength:50
        GivenName: '',//名:maxlength:50
        Name: '',//姓名
        Sex: 1,//性别:1:男,2:女
        Mobile: '',//手机:maxlength:11,第一次填写开通手机帐号,后续可以不填写,但是禁止和第一次填写不同
        Email: '',//邮箱:maxlength:100,第一次填写开通邮箱帐号,后续可以不填写,但是禁止和第一次填写不同
        HospitalTextName: '',//医院名称:认证前不能为空,认证后填写无效,maxlength:200
        ZipCode: '',//邮编:maxlength:50
        TelePhone: '',//固定电话:maxlength:200
        Introduction: '',//简介:maxlength:500
        UserHeadPath: '',//用户头像:maxlength:500 
        Birthday: '' // guandong_20220706
      },
      certificatecount: '',
      genderText: '',
      addressText: '',
      phoneText: '',
      cityName: '',
      areaID: '',
      count: 0,
      isMobileReadOnly: false,
      isEmailReadOnly: false,
      saveDisabled: false,
      rules: {
        surName: { required: true },
        givenName: { required: true },
        email: { required: true, formatEmail: true },
        telphone: {},
        hospitalName: { required: true },
        zipCode: { formatZipCode: true },
        provinceArea: { required: true },
        hospitalAddress: { required: true },
      },
      modalShow: {
        gender: false,
        area: false
      },
      optData: {//选项数据
        gender: [{ text: '男', value: '1' }, { text: '女', value: '2' }],
        product: [],
        areaOpt: {
          country: [],
          province: [],
          city: [],
          area: []
        }
      },
      areaName: {
        1: 'country',
        2: 'province',
        3: 'city',
        4: 'area'
      },
      choseAreaKey: {
        countryIndex: 0,
        provinceIndex: 0,
        cityIndex: 0,
        areaIndex: 0
      },
      showCalendar: false, // guandong_20220706
      defaultBirthDate: new Date()
    }
  },
  methods: {
    init () {
      if (store.getters.user.Account.indexOf('@') < 0) {
        this.isMobileReadOnly = true
        this.params.Mobile = store.getters.user.Account;
      } else {
        this.isEmailReadOnly = true
        this.params.Email = store.getters.user.Account;
      }
    },
    //验证
    validateField () {
      this.$validator.extend('formatEmail', {
        getMessage: field => "请输入正确的邮箱",
        validate: (value) => {
          return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-z0-9_-]+)+$/.test(value)
        }
      });
      this.$validator.extend('formatZipCode', {
        getMessage: field => "请输入正确的邮编",
        validate: (value) => {
          return /^[0-8][0-7]\d{4}$/.test(value)
        }
      });
    },
    //关闭选项弹窗
    closeModal (field) {
      this.modalShow[field] = false;
    },
    //选择性别
    changeGenderOptData (curItem, index) {
      this.genderText = curItem.text;
      this.params.Sex = curItem.value;
      this.modalShow.gender = false;
    },
    //确定选择省市区
    confirmChoseAreaData () {
      let countryText = this.optData.areaOpt.country.length && this.optData.areaOpt.country[this.choseAreaKey.countryIndex].Name;
      let provinceText = this.optData.areaOpt.province.length && this.optData.areaOpt.province[this.choseAreaKey.provinceIndex].Name;
      let cityText = this.optData.areaOpt.city.length && this.optData.areaOpt.city[this.choseAreaKey.cityIndex].Name;
      let areaText = this.optData.areaOpt.area.length && this.optData.areaOpt.area[this.choseAreaKey.areaIndex].Name;
      this.addressText = countryText + '' + provinceText + '' + cityText + '' + areaText;
      //AreaID取最后一级,如果没有取上级
      if (this.optData.areaOpt.area[this.choseAreaKey.areaIndex]) {
        this.params.RegionID = this.optData.areaOpt.area[this.choseAreaKey.areaIndex].AreaID;
      } else {
        this.params.RegionID = this.optData.areaOpt.city[this.choseAreaKey.cityIndex].AreaID;
      }
      this.closeModal('area');
    },
    //获取地区
    getArea (type, AreaID) {
      let subType = type;
      let areaId = AreaID;
      if (subType > 4) {
        return;
      }
      let sendParams = {
        AppID: this.GLOBAL.AppID,
        Method: 'GetAreas',
        AreaID: areaId || '',//地区编号
        Type: type,//地区分类:1:国家,2:省/州,3:市,4:县/区 
      }
      this.$Request(sendParams).then(res => {
        if (res.AreaItems && res.AreaItems.length) {
          if (this.resultArea) {
            this.optData.areaOpt[this.areaName[type]] = res.AreaItems;
            this.optData.areaOpt[this.areaName[type]].map((item, index) => {
              if (type === 1 && (item.AreaID === this.resultArea.CountryID)) {
                this.choseAreaKey.countryIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                // isForeign = this.optData.areaOpt[this.areaName[type]][index].IsForeign;
              }
              if (type === 2 && (item.AreaID === this.resultArea.ProvinceID)) {
                this.choseAreaKey.provinceIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                // isForeign = this.optData.areaOpt[this.areaName[type]][index].IsForeign;
              }
              if (type === 3 && (item.AreaID === this.resultArea.CityID)) {
                this.choseAreaKey.cityIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                // isForeign = this.optData.areaOpt[this.areaName[type]][index].IsForeign;
              }
              if (type === 4 && (item.AreaID === this.resultArea.RegionID)) {
                this.choseAreaKey.areaIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                // isForeign = this.optData.areaOpt[this.areaName[type]][index].IsForeign;
              }
            })
            subType = type + 1;
            this.getArea(subType, areaId);
            subType++;

          } else {
            this.optData.areaOpt[this.areaName[type]] = res.AreaItems;
            areaId = this.optData.areaOpt[this.areaName[type]][0].AreaID;
            // isForeign = this.optData.areaOpt[this.areaName[type]][0].IsForeign;
            subType = type + 1;
            this.getArea(subType, areaId);
            subType++;
          }
        } else {
          this.optData.areaOpt[this.areaName[type]] = [];
        }
      })
    },
    getSubArea (picker, value, index) {
      let subLevel = parseInt(value.Type) + 1;
      let AreaID = value.AreaID;
      let IsForeign = value.IsForeign;
      if (value.Type == 1) {
        this.choseAreaKey.provinceIndex = 0;
        this.choseAreaKey.cityIndex = 0;
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.countryIndex = index;
      } else if (value.Type == 2) {
        this.choseAreaKey.cityIndex = 0;
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.provinceIndex = index;
      } else if (value.Type == 3) {
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.cityIndex = index;
      } else if (value.Type == 4) {
        this.choseAreaKey.areaIndex = index;
      }
      this.getArea(subLevel, AreaID);
    },
    //保存
    handleSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          Toast.loading({
            duration: 0,
            message: '数据保存中...',
            overlay: true
          });
          this.saveDisabled = true;
          this.params.Name = this.params.SurName + this.params.GivenName;
          this.$Request(this.params).then(res => {
            Toast.clear();
            Toast.success({
              duration: 3000,
              message: '保存成功'
            });
            this.$store.dispatch('GetUserInfo').then(res => {
              this.saveDisabled = false;
              this.$router.push({
                path: '/'
              })
            })
          }, err => {
            setTimeout(() => {
              Toast.clear();
              this.saveDisabled = false;
            }, 3000)
          })
        }
      })
    },
    // guandong_20220706
    birthConfirm (date) {
      this.params.Birthday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      this.showCalendar = false
    },
  },
  watch: {
    'optData.address': {
      handler (ne, ol) {
        this.optData.address = ne
      },
      deep: true
    }
  },
  mounted () {
    this.validateField();
    this.init();
    this.getArea(1, null, false);
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 20px;
  margin-bottom: 100px;
  .header-wrap {
    width: 100%;
    height: 300px;
    .head-icon-box {
      width: 300px;
      height: 300px;
      margin: 20px auto;
      text-align: center;

      .head-name {
        color: #6c6c6c;
        font-size: 14px;
      }
    }
  }
  .content-wrap {
    padding-bottom: 100px;
  }
  .btn-wrap {
    position: fixed;
    height: 150px;
    width: 100%;
    right: 0;
    bottom: 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    .btn-box {
      width: 90%;
      margin: 0 auto;
    }
  }
  .van-button--primary {
    color: #fff;
    background-color: #269cca;
    border: 0.02667rem solid #269cca;
  }
  .van-icon {
    z-index: -1 !important;
  }
}
.select-area-wrap {
  .btn {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #eeeeee;
    a {
      color: @blue;
    }
  }
  .list-box {
    display: flex;
    justify-content: space-around;
    padding-bottom: 20px;
  }
  .area-list {
    width: 25%;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/member/basic-info.vue